<template>
  <DialogComponent
    hashBase="modalvisible"
    ref="dialog"
    v-slot="{ data: { dialogIsVisible } }"
  >
    <div
      class="relative z-10"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
      :class="{
        'pointer-events-all': dialogIsVisible,
        'pointer-events-none': !dialogIsVisible,
      }"
    >
      <div
        class="fixed inset-0 bg-black bg-opacity-30 transition-opacity"
        :class="{
          'ease-out duration-100 opacity-100 ': dialogIsVisible,
          'ease-in duration-100 opacity-0 pointer-events-none':
            !dialogIsVisible,
        }"
      ></div>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div
          class="flex min-h-full items-center justify-center p-4 text-center lg:items-center lg:p-0"
        >
          <div
            class="absolute w-full h-full"
            @click="
              () => {
                if (onOverlayClick) onOverlayClick()
                else if (overlayerCanDismiss) hide()
              }
            "
          ></div>

          <div
            :class="{
              'ease-out duration-300 opacity-100 top-0 ': dialogIsVisible,
              'ease-in duration-200 opacity-0 top-4 lg:top-0 pointer-events-none scale-[0.8]':
                !dialogIsVisible,
            }"
            class="boxComponent relative overflow-hidden glassBg text-left transition-all lg:my-8 max-w-[90%] lg:w-[max-content] inline-block"
          >
            <div class="w-full h-full">
              <div class="pb-4 pt-5 lg:p-6 lg:pb-4" v-if="dialogIsVisible">
                <div class="lg:flex lg:items-start">
                  <div
                    v-if="!!$slots.icon && iconLeftBg"
                    :style="{ 'background-color': iconLeftBg }"
                    class="px-4 mx-auto flex flex-shrink-0 items-center justify-center rounded-full lg:mx-0"
                  >
                    <div class="p-2">
                      <slot name="icon"> </slot>
                    </div>
                  </div>
                  <div
                    class="lg:text-left"
                    :class="{
                      'mt-3 lg:ml-4 lg:mt-0': $slots.icon && iconLeftBg,
                    }"
                  >
                    {{ mano }}

                    <slot name="header">
                      <slot name="titleContainer">
                        <span
                          class="px-4 text-2xl lg:text-2xl block font-medium"
                          ><slot name="titleText"></slot
                        ></span>
                      </slot>
                      <div class="py-2"></div>
                      <slot name="subtitleContainer">
                        <span
                          class="textComponent px-4 text-sm lg:text-base block title-color"
                          ><slot name="subtitleText"></slot
                        ></span>
                      </slot>
                      <slot name="banner"> </slot>
                      <div class="py-4"></div>
                    </slot>
                    <slot name="fullContent">
                      <div class="mt-2 max-h-[80dvh] overflow-auto">
                        <div class="px-4">
                          <slot></slot>
                        </div>
                      </div>
                    </slot>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  dialogIsVisible &&
                  (!!$slots.primaryButton || !!$slots.cancelButton)
                "
                class="px-4 py-3 flex lg:px-6 gap-3"
                :class="{ 'flex-row-reverse': buttonsToRight }"
              >
                <button
                  class="p-4 ripple"
                  v-if="!!$slots.primaryButton"
                  @click="
                    () => {
                      onPrimaryClick()
                    }
                  "
                  :loading="primaryButtonLoading"
                >
                  <span class="title-color">
                    <slot name="primaryButton"></slot>
                  </span>
                </button>
                <button
                  class="p-4 ripple"
                  v-if="!!$slots.cancelButton"
                  @click="
                    () => {
                      if (onCancelClick) onCancelClick()
                      else hide()
                    }
                  "
                >
                  <span class="title-color">
                    <slot name="cancelButton"></slot>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </DialogComponent>
</template>

<script>
import { defineComponent } from 'vue'
import DialogComponent from './DialogComponent.vue'

export default defineComponent({
  name: 'FeesComponent',
  components: { DialogComponent },
  props: {
    init: {
      type: Function,
      default: (show, hide, isVisible) => {},
    },
    onPrimaryClick: {
      type: Function,
      default: () => {},
    },
    onOverlayClick: {
      type: Function,
      default: null,
    },
    onCancelClick: {
      type: Function,
      default: null,
    },
    onBackButtonClick: {
      type: Function,
      default: null,
    },
    iconLeftBg: {
      type: String,
      default: 'red',
    },
    overlayerCanDismiss: {
      type: Boolean,
      default: true,
    },
    buttonsToRight: {
      type: Boolean,
      default: true,
    },
    primaryButtonLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    show() {
      this.$refs.dialog.show()

    },
    hide() {
      this.$refs.dialog.hide()
    },
    isVisible() {
      return this.$refs.dialog.isVisible()
    },
  },
})
</script>
